import React from 'react'
import {Link as GatsbyLink} from 'gatsby'

import {pathJoin, getLocalePath, isFullSiteLink} from '../utils/helpers'
import {useGatsbyData} from '../context/gatsbyDataContext'

function Link({hasLocale, target, to, ...restProps}) {
  const {locale} = useGatsbyData().pageContext
  if (target || isFullSiteLink(to)) {
    return <a href={to} target={target} {...restProps} /> // eslint-disable-line
  }
  return (
    <GatsbyLink
      to={pathJoin(hasLocale ? getLocalePath(locale) : '', to)}
      {...restProps}
    />
  )
}

function ObjectLink({hasLocale, text, linkTo, ...restProps}) {
  return (
    <Link hasLocale={hasLocale} to={linkTo} {...restProps}>
      {text}
    </Link>
  )
}

export {Link, ObjectLink}
